/*
 * @Date: 2026-01-27 00:39:34
 * @LastEditors: ryan.zheng@momenta.ai
 * @LastEditTime: 2026-03-14 17:01:54
 */
import { TableOutlined, WarningOutlined, FormOutlined, DashboardOutlined, VideoCameraOutlined } from '@ant-design/icons';
import type { MenuDataItem } from '@ant-design/pro-layout';

const asideMenuConfig: MenuDataItem[] = [
  {
    name: 'pad',
    path: '/pad',
    icon: <VideoCameraOutlined />,
  }
];

export { asideMenuConfig };
